import { Controller } from 'stimulus'

/**
 * Manages js for the Goldy Sidebar(StimulusJS
 * controller)
 *
 * @class SidebarController
 * @memberof Controllers
 */
export default class extends Controller {
  /**
   * @function Controllers.SidebarController.connect
   * @memberof Controllers
   * @description Toggles a hidden class on connect to prevent element flash.
   *
   * @return {undefined} manipulates DOM
   *
   */
  connect() {
    const headerController = this.application.getControllerForElementAndIdentifier(document.body, 'header-short')
    headerController.initialMobileToggle()
    this.element.classList.remove('hidden')
  }
}
